/* Tonoko — Carrito. Actualiza cantidades y quita líneas por AJAX (/cart/change.js)
   y recalcula totales + barra de envío sin recargar. Respaldo: envío nativo del form. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tnk-cart]');
  if (!root) return;
  var form = root.querySelector('[data-tnk-cart-form]');
  if (!form) return;

  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
  var subtotalEl = root.querySelector('[data-tnk-subtotal]');
  var shipFill = root.querySelector('[data-tnk-ship-fill]');
  var shipMsg = root.querySelector('[data-tnk-ship-msg]');
  var updateBtn = root.querySelector('[data-tnk-cart-update]');
  var busy = false;

  // Con JS el botón "Actualizar carrito" sobra (la actualización es automática).
  if (updateBtn) updateBtn.hidden = true;

  function fmt(cents) {
    return '$' + (Number(cents) / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function shipBar(total) {
    if (!shipFill) return;
    var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
    shipFill.style.width = pct + '%';
    if (shipMsg) {
      shipMsg.textContent =
        total >= threshold ? '✓ ¡Tienes envío gratis!' : 'Te faltan ' + fmt(threshold - total) + ' para envío gratis';
    }
  }

  function refreshBadge(count) {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-tnk-cart-count]'),
    );
    nodes.forEach(function (n) {
      n.textContent = count;
    });
  }

  function refreshUI(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
    Array.prototype.slice.call(root.querySelectorAll('.citem')).forEach(function (citem) {
      var key = citem.getAttribute('data-key');
      var found = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) {
          found = cart.items[i];
          break;
        }
      }
      if (!found) {
        if (citem.parentNode) citem.parentNode.removeChild(citem);
        return;
      }
      var priceEl = citem.querySelector('[data-tnk-line-price]');
      if (priceEl) priceEl.textContent = fmt(found.final_line_price);
      var qtyEl = citem.querySelector('[data-tnk-qty]');
      if (qtyEl) qtyEl.value = found.quantity;
      citem.setAttribute('data-unit', found.final_price);
    });
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
    shipBar(cart.total_price);
    refreshBadge(cart.item_count);
  }

  function updateLine(key, qty) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject();
      })
      .then(function (cart) {
        refreshUI(cart);
        busy = false;
      })
      .catch(function () {
        busy = false;
        form.submit();
      }); // respaldo nativo
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest ? e.target.closest('[data-tnk-step]') : null;
    if (step) {
      var citem = step.closest('.citem');
      var input = citem && citem.querySelector('[data-tnk-qty]');
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-tnk-step'), 10));
      updateLine(input.getAttribute('data-key'), next);
      return;
    }
    var rem = e.target.closest ? e.target.closest('[data-tnk-remove]') : null;
    if (rem) {
      e.preventDefault();
      updateLine(rem.getAttribute('data-key'), 0);
    }
  });

  root.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-tnk-qty]')) {
      var v = Math.max(0, parseInt(e.target.value, 10) || 0);
      updateLine(e.target.getAttribute('data-key'), v);
    }
  });
})();
